module.exports = __webpack_public_path__ + "images/close@3x.png?757d2662";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/close@3x.png
// module id = 611
// module chunks = 7